module.exports = __webpack_public_path__ + "img/PT97.6f7da606.png";